import React from 'react';
import { FiLinkedin } from "react-icons/fi";
import ScrollAnimation from "react-animate-on-scroll";


const Member = ({image,link, title, description}) => {
    return (
            <div className="col-lg-4 col-md-6 col-sm-6 col-12">
                <ScrollAnimation 
                animateIn="fadeInUp"
                animateOut="fadeInOut"
                animateOnce={true}>
                    <div className={'service service__style--1 bg-color-blackest radius mt--25 text-center'} style={{height:"500px"}}>
                        <div className="icon">
                            <img src={image} alt="Member" width={"250px"}/>
                        </div>
                        <div className="content">
                            <h4 className="title w-600"><a href={`${link}`} rel="noreferrer" target='_blank' dangerouslySetInnerHTML={{__html: title}}></a></h4>
                            <p className="description b1 color-gray mb--0" dangerouslySetInnerHTML={{__html: description}}></p>
                        </div>
                        <a href={`${link}`} rel="noreferrer"  target='_blank'>
                        <div className='icon pt-2'>
                            <FiLinkedin/>
                        </div>
                        </a>
                    </div>
                </ScrollAnimation>
            </div>
    )
}
export default Member;